import {
  ApiResponse,
  BasePaginationResponse,
  User,
  Customer,
  Area,
  Compound,
  Developer,
} from "@/modules/common/dtos/index.v2";
import { Referral } from "@/modules/leads/types";

export interface SalesResponseData
  extends BasePaginationResponse<SalesResponseV2> {
  exactMatches: SalesResponseV2[];
}

export enum FinishingTypes {
  Finished = "finished",
  SemiFinished = "semi_finished",
  Unfinished = "unfinished",
}

export interface SalesResponseV2 {
  oldId?: number;
  id: number;
  uid: string;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  agentId: number | null;
  dateOfEOI: string | null;
  agent: User;
  expectedContractionDate: string | null;
  expectedValue: number | null;
  dateOfBlocked: string | null;
  blockUpdateDate: string | null;
  dateOfReservation: string | null;
  unitNumber: string | null;
  propertyTrackUid?: string | null;
  unitValue?: number;
  unitValueCurrency: string | null;
  methodOfContact: string | null;
  downPayment: number | null;
  dateOfDownPayment: string | null;
  dateOfContraction: string | null;
  actualDateOfContraction: string | null;
  parentId: number | null;
  linkedSaleType: string | null;
  targetMultiplier: number;
  unitLocation: string;
  nameOnContract: string | null;
  saleCategory: string | null;
  actualValue: number | null;
  yearsOfPayment: number | null;
  cashPrice: number | null;
  partnerId: number | null;
  googleOciConversionSent: boolean;
  comment: string | null;
  telephone: string | null;
  exactMatch?: boolean;
  unitArea?: number | null;
  finishing?: FinishingTypes | null;
  leadReferral?: Referral;
  lead: {
    uid: string;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
    oldId: number;
    journeys: Array<{
      uid: string;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
      dateOfLastContact: string;
      user: User;
    }>;
    customer: Customer;
    dateOfLastRequest: string;
    dateOfLastContact: string;
    validityTime: string;
    poolValidityTime: string;
    duplicate: boolean;
    archived: boolean;
  } | null;

  saleType: {
    uid: string;
    name: string;
  };

  propertyType: {
    name?: string;
    uid?: string;
  } | null;
  area: Area;
  developer: Developer;

  compound: Compound;
  teamLeader?: User | null;
  manager?: User | null;
  seniorManager?: User | null;
  associateManager?: User | null;
  director?: User | null;
  headOfSales?: User | null;
  seniorDirector?: User | null;
  associateDirector?: User | null;

  [key: string]: any;
}

export type SalesResponse = ApiResponse<SalesResponseData>;
